import { ThemeTokens } from '@acp/core-ui';
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Text,
} from '@chakra-ui/react';

type MobileNavigationMenuProps = {
    label: string;
    children: React.ReactNode;
};

export function MobileNavigationMenu({ label, children }: MobileNavigationMenuProps) {
    return (
        <Accordion allowToggle>
            <AccordionItem borderTopWidth={0}>
                <AccordionButton justifyContent="space-between" px={ThemeTokens.Defaults.px} py={ThemeTokens.Defaults.py}>
                    <Text fontWeight={500}>{label}</Text>
                    <AccordionIcon />
                </AccordionButton>
                <AccordionPanel bg="white" p={0} mb={-1}>
                    {children}
                </AccordionPanel>
            </AccordionItem>
        </Accordion>
    );
}
